import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.64 3.10901H4.36c-.62559.00106-1.22525.25004-1.6676.6924-.44236.44235-.69134 1.04201-.6924 1.6676V18.529c.00106.6256.25004 1.2253.6924 1.6676.44235.4424 1.04201.6914 1.6676.6924h15.28c.31.0003.617-.0606.9034-.1791.2865-.1185.5468-.2923.766-.5115.2192-.2192.393-.4795.5115-.7659.1185-.2865.1794-.5935.1791-.9035V5.46901c.0003-.30999-.0606-.617-.1791-.90344-.1185-.28645-.2923-.54672-.5115-.76592-.2192-.2192-.4795-.39302-.766-.51153-.2864-.11851-.5934-.17937-.9034-.17911zM16 6.00001c.3956 0 .7822.1173 1.1111.33706.3289.21976.5853.53212.7367.89757.1513.36545.1909.76759.1138 1.15555-.0772.38796-.2677.74433-.5474 1.02403-.2797.27971-.6361.47019-1.024.54736-.388.07722-.7901.03756-1.1556-.11381-.3654-.15138-.6778-.40772-.8975-.73662C14.1173 8.78225 14 8.39557 14 8.00001c0-.53043.2107-1.03914.5858-1.41421.3751-.37508.8838-.58579 1.4142-.58579zM4 19l5.71-8 3.56 4.98 2.16-2.69L20 19H4z",
    fill: "currentColor"
  }));
});